import React, { useContext, useEffect } from "react"
// useCallback, 

import { Button } from "reactstrap"
// import cn from "classnames"

import as from "../styles/auth-styles.module.scss"

import { AUTH_FLOW_COMPONENTS, AuthContext } from "../contexts/Auth"

const MAX_ATTEMPTS = 3
const RETRY_INTERVAL = 5000

const EmailVerification = () => {

    const {
        authMsg,
        currentUser,
        emailVerified,
        setCurrAuthComponent,
        setAuthMsg,
        setEmailVerified
    } = useContext(AuthContext)

    const resendVerificationEmail = () => {
        if (!currentUser.emailVerified) {
            // console.log("Resending verification email")
            currentUser.sendEmailVerification()
                .then(() => console.log("email verification message sent")) //recheckEmailVerification())
                .catch((error) => console.log(error))
        } else {
            console.log("email address already verified")
        }
    }

    const checkForEmailVerification = () => {
        let intervalID;
        let attempt=0
        // check every RETRY_INTERVAL seconds that the email is verified, a max of MAX_ATTEMPTS times
        intervalID = setInterval(
            () => {
                console.log("checking for email verification attempt:", attempt+1);
                currentUser.reload().then(() => {
                    if (currentUser.emailVerified) {
                        console.log("email verification confirmed")
                        setEmailVerified(true)
                        clearInterval(intervalID)
                    }
                    if (++attempt === MAX_ATTEMPTS) {
                        console.log("email verifiction max attempts exceeded")
                        clearInterval(intervalID)
                    }
                })
            },
            (attempt === 0) ? 10 : RETRY_INTERVAL
        )

        // console.log("checking if user email is verified")
        // currentUser.reload()
        //     .then(() => {
        //         if (currentUser.emailVerified) {
        //             // setEmailVerified(true)
        //             // setCurrAuthComponent(AUTH_FLOW_COMPONENTS.LOGIN)
        //             // setAuthMsg("")
        //         } else {
        //             recheckEmailVerification()
        //         }
        //     })
    }

    // const recheckEmailVerification = useCallback(
    //     () => {
    //         if(!currentUser.emailVerified) {
    //             setTimeout(() => checkVerification(), 10000);
    //         }
    //     },
    //     [currentUser.emailVerified, checkVerification]
    // )

    // useEffect(
    //     () => {
    //         if (currentUser.emailVerified) {
    //         //     setEmailVerified(false)
    //         //     recheckEmailVerification()
    //         // } else {
    //             setEmailVerified(true)
    //             setAuthMsg("")
    //             setCurrAuthComponent(AUTH_FLOW_COMPONENTS.LOGIN)
    //         }
    //     },
    //     [currentUser.emailVerified, setCurrAuthComponent, setAuthMsg, setEmailVerified]
    // )

    useEffect(
        () => {
            if (emailVerified) {
                setAuthMsg("")
                setCurrAuthComponent(AUTH_FLOW_COMPONENTS.LOGIN)
                window.location.reload()
            }
        },
        [emailVerified, setAuthMsg, setCurrAuthComponent]
    )

    return (
      <div className={as.container}>
        <div className={as.row}>
          <h4>{authMsg}</h4>
        </div>
        <div className={as.row}>
          <p>
            After following that link to verify your email address, Click
            <Button color="link" size="sm" onClick={checkForEmailVerification}>
              Login
            </Button>
            to continue.
          </p>
        </div>
        <div className={as.row}>
          <dl>
            <dt>
              <span className="text-danger">
                Didn't recieve a verification email? Verification link expired?
              </span>
            </dt>
            <dd style={{marginLeft: "20px"}}>
              Click
              <Button
                size="sm"
                color="primary"
                //   className={cn(as.btn, as["btn-small"], as["btn-primary"])}
                onClick={resendVerificationEmail}
              >
                Resend Verification Email
              </Button>{" "}
              and then follow the instructions on this page.
            </dd>
          </dl>
        </div>
        <div className={as.row}></div>
      </div>
    );
}

export default EmailVerification